import { render, staticRenderFns } from "./serviceCase.vue?vue&type=template&id=63070d7c&scoped=true"
import script from "./serviceCase.vue?vue&type=script&lang=js"
export * from "./serviceCase.vue?vue&type=script&lang=js"
import style0 from "./serviceCase.vue?vue&type=style&index=0&id=63070d7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63070d7c",
  null
  
)

export default component.exports